import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import noticia1 from "../image/bot-agente.png";
import noticia2 from "../image/voce-sabia.png";
import noticia3 from "../image/fraude.png";
import noticia4 from "../image/apps.png";
import noticia5 from "../image/design-uiux.png";

const NewsCarousel = () => {
  // Dados das notícias (pode ser substituído por uma chamada API)
  const news = [
    {
      id: 1,
      excerpt: "Qual a diferença de Bot e Agente? Acompanhe o que a GaekWare tem a dizer sobre isso.",
      image: noticia1,
      link: "https://www.instagram.com/gaekware/p/DJZZVnUgEvK/"
    },
    {
      id: 2,
      excerpt: "Você sabia que é possível registrar presença em sala de aula sem dizer uma palavra?",
      image: noticia2,
      link: "https://www.instagram.com/gaekware/p/DJUPrUdAnH9/"
    },
    {
      id: 3,
      excerpt: "Veja a pesquisa feita com professores de diversas instituições. O reultado é surpreendente!",
      image: noticia3,
      link: "https://www.instagram.com/gaekware/p/DJCOSCGgESV/"
    },
    {
      id: 4,
      excerpt: "Separamos 3 apps essenciais para facilitar sua vida na sala de aula. Confira no link!",
      image: noticia4,
      link: "https://www.instagram.com/gaekware/p/DI4J6zMg0nD/"
    },
    {
      id: 5,
      excerpt: "Você sabe o que é Design UX/UI? Descubra uma parte essencial de cada aplicação.",
      image: noticia5,
      link: "https://www.instagram.com/gaekware/p/DIyxoodsAhp/"
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="news-carousel-container">
      <Slider {...settings}>
        {news.map((item) => (
          <div key={item.id} className="news-card">
            <div className="news-image-container">
              <img src={item.image} alt={item.title} className="news-image" />
            </div>
            <div className="news-content">
              <h3 className="news-title">{item.title}</h3>
              <p className="news-excerpt">{item.excerpt}</p>
              <a href={item.link} className="read-more-link">
                Veja mais ➔
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsCarousel;